import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setError, setHouseId } from '../filters';
import { ECurrentErrorField } from '../filters/types';
import { fetchValidateAddress } from '../../repositories/price-estimator/v1/validate-address';
/**
 * Валидатор фильтров для типа оцениваемой недвижимости "Дома"
 * Проверяет наличие обязательных полей, соответствие их условиям
 * Отправляет запрос к АПИ, валидируя адрес
 * */

export var validateLandFilters = function validateLandFilters() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var state, _state$filters, address, landArea, response, errors, error, key, message;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              _state$filters = state.filters, address = _state$filters.address, landArea = _state$filters.landArea;

              if (address) {
                _context.next = 5;
                break;
              }

              dispatch(setError({
                currentErrorField: ECurrentErrorField.address,
                errorText: 'Укажите адрес'
              }));
              return _context.abrupt("return", false);

            case 5:
              if (landArea) {
                _context.next = 8;
                break;
              }

              dispatch(setError({
                currentErrorField: ECurrentErrorField.landArea,
                errorText: 'Укажите площадь участка'
              }));
              return _context.abrupt("return", false);

            case 8:
              if (!(landArea > 9999)) {
                _context.next = 11;
                break;
              }

              dispatch(setError({
                currentErrorField: ECurrentErrorField.landArea,
                errorText: 'Недопустимое значение'
              }));
              return _context.abrupt("return", false);

            case 11:
              _context.prev = 11;
              _context.next = 14;
              return fetchValidateAddress({
                httpApi: context.httpApi,
                parameters: {
                  address: address
                }
              });

            case 14:
              response = _context.sent;

              if (!(response.statusCode === 400)) {
                _context.next = 21;
                break;
              }

              errors = response.response.errors || [];
              error = errors[0] || {};
              key = error.key, message = error.message;

              if (key && message) {
                dispatch(setError({
                  currentErrorField: key,
                  errorText: message
                }));
              }

              return _context.abrupt("return", false);

            case 21:
              if (response.response.isValid) {
                _context.next = 24;
                break;
              }

              dispatch(setError({
                currentErrorField: ECurrentErrorField.address,
                errorText: 'Оцениваем дома только в Москве и МО'
              }));
              return _context.abrupt("return", false);

            case 24:
              if (response.response.houseId) {
                dispatch(setHouseId({
                  houseId: response.response.houseId
                }));
              }

              _context.next = 31;
              break;

            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](11);
              context.logger.error('Unable to validate suburban land address', _context.t0);
              return _context.abrupt("return", false);

            case 31:
              return _context.abrupt("return", true);

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 27]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};